<template>
  <div>
    <div class="shadow-sm bg-white navbar_border">
      <div class="container ">
        <div class="row justify-content-between align-items-center">
          <div class="col-6 text-left" @click.prevent="toLanding">
            <div class="navbar-brand py-0">
              <div class="PcDevice">
                <span class="WidthLongLogo">
                  <img src="../assets/images/Exhibition_Logo2.jpg" height="85px" alt="" />
                </span>
                <span class="WidthShortLogo">
                  <img src="../assets/images/Middle_Exhibition_Logo.jpg" height="85px" alt="" />
                </span>
              </div>
              <div class="MbDevice">
                <img src="../assets/images/Mb_Exhibition_Logo.jpg" width="210px" height="70px" alt="" />
              </div>
            </div>
          </div>

          <div class="col-6 text-right">
            <div class="PcDevice">
              <button class="btn btn-primary px-5 py-2 mr-1" @click.prevent="toLanding">
                Landing
              </button>
            </div>

            <div class="MbDevice">
              <button class="btn btn-primary px-4 py-1 mr-1" @click.prevent="toLanding">
                Landing
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },

    methods: {
      toLanding() {
        document.location.href = `https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Landing`
      },
    },
  }
</script>

<style scoped>
  .nav_top {
    border-bottom: rgb(207, 207, 207) solid 1px;
  }
</style>
